<h1 mat-dialog-title>
  {{ 'map.sidebar.fibra.form.title_modal_edit' | translate : { name: fibra?.fiber_number || fibra?.id_fibra_gis || ' ' } }}
</h1>

<div mat-dialog-content>
  <form [formGroup]="form" *ngIf="form" style="padding: 8px 0px">
    <div class="row mb-4">
      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.fibra.form.stato' | translate }}</mat-label>
          <mat-select formControlName="stato">
            <mat-option *ngFor="let stato of statoFibra" [value]="stato.value">
              {{ stato.label }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('stato').hasError('required')">
            <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.fibra.form.cliente' | translate }}</mat-label>
          <input matInput formControlName="cliente" />
        </mat-form-field>
      </div>

      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.fibra.form.circuito_td' | translate }}</mat-label>
          <input matInput formControlName="circuito_td" />
        </mat-form-field>
      </div>

      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.fibra.form.codice_servizio_tecnico' | translate }}</mat-label>
          <input matInput formControlName="codice_servizio_tecnico" />
        </mat-form-field>
      </div>
      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.fibra.form.porte_apparato' | translate }}</mat-label>
          <input matInput formControlName="porte_apparato" />
        </mat-form-field>
      </div>
      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.fibra.form.porte_apparato_2' | translate }}</mat-label>
          <input matInput formControlName="porte_apparato_2" />
        </mat-form-field>
      </div>
      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.fibra.form.segment_rc' | translate }}</mat-label>
          <input matInput formControlName="segment_rc" />
        </mat-form-field>
      </div>
      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.fibra.form.note' | translate }}</mat-label>
          <input matInput formControlName="note" />
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" color="primary">{{ 'common.close' | translate }}</button>
  <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="onSubmit()" *ngIf="form">
    {{ 'common.save' | translate }}
  </button>
</div>

<ng-template #errorRequired>{{ 'map.sidebar.fibra.form.error_required' | translate }}</ng-template>
